export const ymapsKey = 'b84b9c75-2d59-453c-bfb0-f751fc1e972a';
export const apikey = '70db92ca-6999-44ba-a185-a45a7a23e9c8';